var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-row border-b",class:{
      'border-grey-800': _vm.hasState('dark'),
      'border-grey-200': !_vm.hasState('dark'),
    }},_vm._l((_vm.tabs),function(tab){return _c('span',{key:tab,staticClass:"p-4 margin-b-minus text-sm cursor-pointer gp-styleEditor-tabs",class:{
        'text-red': _vm.tabsWithErrors.includes(tab),
        'text-pink border-b-2 border-pink':
          !_vm.tabsWithErrors.includes(tab) && tab === _vm.selected,
        'text-grey-500':
          !_vm.tabsWithErrors.includes(tab) &&
          tab !== _vm.selected &&
          _vm.hasState('dark'),
        'text-grey-800':
          !_vm.tabsWithErrors.includes(tab) &&
          tab !== _vm.selected &&
          !_vm.hasState('dark'),
      },on:{"click":function($event){return _vm.openTab(tab)}}},[_vm._v(" "+_vm._s(tab)+" "),(_vm.tabsWithErrors.includes(tab))?_c('i',{staticClass:"fas fa-exclamation-triangle"}):_vm._e()])}),0),_vm._l((_vm.tabs),function(tab){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected === tab),expression:"selected === tab"}],key:tab},[_vm._t(tab)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }